import { PageWithHeader, Content } from '@backstage/core-components';
import { 
  CustomHomepageGrid,
  HomePageToolkit,
  HomePageStarredEntities,
} from '@backstage/plugin-home';
import { HomePageSearchBar } from '@backstage/plugin-search';
import { SearchContextProvider } from '@backstage/plugin-search-react';

export const HomePage = () => {
  return (
    <SearchContextProvider>
      <PageWithHeader title="IDP Home" themeId="home">
        <Content>
          <CustomHomepageGrid>
            <HomePageSearchBar />
            <HomePageToolkit
              tools={[
                {
                  url: '/catalog',
                  label: 'Software Catalog',
                  icon: <></>,
                },
                {
                  url: '/docs',
                  label: 'TechDocs',
                  icon: <></>,
                },
              ]}
            />
            <HomePageStarredEntities />
          </CustomHomepageGrid>
        </Content>
      </PageWithHeader>
    </SearchContextProvider>
  );
};
